import { gql } from '@apollo/client'

export const CalendarQuery = gql`
  query Calendar($companyId: ID!, $eventFilters: EventFilters, $shiftFilters: ShiftFilters) {
    events(companyId: $companyId, filters: $eventFilters) {
      nodes {
        id
        description
        state
        dateOut
        dateReturn
      }
    }

    currentUser {
      id
      shifts(filters: $shiftFilters) {
        id
        shiftRole { id name }
        event { id description state }
        start
        finish
      }
    }
  }
`
